const EXCHANGE_ROUTES = {
  path: 'exchanges',
  name: 'exchanges.index',
  component: () => import('@/pages/Exchanges/ExchangesPage.vue'),
};

export default EXCHANGE_ROUTES;
